// extracted by mini-css-extract-plugin
export default {"Container":"switchingmodelrecommendmessage_Container__7sQ8b","Model":"switchingmodelrecommendmessage_Model__-1xhS"};